import { useEffect } from 'react';
import { useState } from 'react';
import { checkPermissionGet } from 'utils/API/Merchant APIs/MerchantApiCalls';
import AepsSDK from 'views/AepsSDK';

const AepsSdkCashDeposit = () => {
    const [sdkCred, setSdkCred] = useState({});
    const handleCheckPermission = async () => {
        try {
            const aeps_type = 'CD';
            const params = {
                aeps_type
            };
            const response = await checkPermissionGet(params);
            const Data = response?.data;
            const apiUser = Data?.sdk_apiusername;
            const bcAgentId = Data?.bcagentId;
            const passKey = Data?.pass_key;
            const sdk_token = Data?.sdk_token;
            setSdkCred({ apiUser, bcAgentId, passKey, token: sdk_token, cd_amount: '' });
        } catch (error) {
            console.log(error.message);
            handleCatchError(error);
        }
    };
    useEffect(() => {
        handleCheckPermission();
    }, []);
    return <AepsSDK serviceName="cash-deposit" creds={sdkCred} />;
};

export default AepsSdkCashDeposit;
